import { InjectionToken } from '@angular/core';
import { NgControl } from '@angular/forms';

export interface SuiFormFieldControl {
  readonly id: string;
  readonly focused: boolean;
  readonly empty: boolean;
  readonly errorState: boolean;
  readonly controlType: string;
  readonly ngControl: NgControl | null;
}

export const SUI_FORM_FIELD_CONTROL = new InjectionToken<SuiFormFieldControl>(
  'SUI_FORM_FIELD_CONTROL',
);
